import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { withLocalizer } from "utilities/withLocalizer";

const TimeOutModal = (props) => {   
    return (
        <div>
            <Dialog
                open={true}
                onClose={props.handleNavigate}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {props.localize("qma-quote-timeout-title")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {props.localize("qma-quote-timeout-message")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleNavigate} autoFocus>{props.localize("qma-quote-timeout-button")}</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}; 

export default withLocalizer(TimeOutModal);